import React, { useState, useMemo, useCallback } from 'react';
import './Carousel.css';
import { BrowserView, MobileView } from 'react-device-detect';
import CheckoutCarousel from './CheckoutCarousel';
import translate from '../../components/languages';

const Carousel = ({ photosRoomList, purePhotosRoomArray }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const itemsPerSlide = 3;

  // Memoize expensive calculations
  const { currentPage, totalPages, pagination } = useMemo(() => {
    const current = Math.ceil((currentIndex + 1) / itemsPerSlide);
    const total = Math.ceil(photosRoomList.length / itemsPerSlide);
    return {
      currentPage: current,
      totalPages: total,
      pagination: `${current}/${total}`,
    };
  }, [currentIndex, photosRoomList.length, itemsPerSlide]);

  // Memoize callback functions to prevent unnecessary re-renders
  const nextSlide = useCallback(() => {
    if (currentPage < totalPages) {
      const nextIndex = Math.min(
        currentIndex + itemsPerSlide,
        photosRoomList.length - itemsPerSlide,
      );
      setCurrentIndex(nextIndex);
    }
  }, [
    currentPage,
    totalPages,
    currentIndex,
    itemsPerSlide,
    photosRoomList.length,
  ]);

  const prevSlide = useCallback(() => {
    if (currentIndex > 0) {
      const prevIndex = Math.max(currentIndex - itemsPerSlide, 0);
      setCurrentIndex(prevIndex);
    }
  }, [currentIndex, itemsPerSlide]);

  return (
    <div className="checkout-sleep-section">
      <div className="title-description mb-2 checkout-mobile-container include-title-green-100">
        <p>{translate.t('sleepingZone')}</p>
      </div>
      <div className="checkout-bed-carousel">
        <BrowserView>
          <span
            style={{
              position: 'absolute',
              top: 0,
              right: '30px',
              fontFamily: 'SharpGrotesk',
              fontSize: '13px',
            }}
          >
            {pagination}
          </span>
        </BrowserView>

        <BrowserView>
          <div className="checkout-alt-carousel-container">
            <button
              className="checkout-alt-prev"
              onClick={prevSlide}
              disabled={currentIndex === 0}
            >
              &#10094;
            </button>
            <button
              className="checkout-alt-next"
              onClick={nextSlide}
              disabled={currentPage >= totalPages}
            >
              &#10095;
            </button>
            <div className="checkout-alt-carousel-wrapper">
              <div className="checkout-alt-carousel">
                {photosRoomList
                  .slice(currentIndex, currentIndex + itemsPerSlide)
                  .map((photo, index) => photo)}
              </div>
            </div>
          </div>
        </BrowserView>

        <MobileView>
          <div style={{ paddingLeft: '30px' }}>
            <div
              style={{
                marginLeft: '34%',
                marginBottom: '20px',
                position: 'relative',
              }}
            >
              <span
                className="checkout-pagination"
                style={{
                  fontFamily: 'SharpGrotesk',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  padding: '29px',
                }}
              >
                {pagination}
              </span>
            </div>
            <CheckoutCarousel
              items={photosRoomList}
              pureItems={purePhotosRoomArray}
              infinite={false}
              showArrows={true}
              showAllBtn={false}
            />
          </div>
        </MobileView>
      </div>
    </div>
  );
};

export default Carousel;
